import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const LoginRightIcon = ({ width = 271, height = 265 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={remCss(width)}
    height={remCss(height)}
    viewBox='0 0 271 265'
  >
    <g mask='url(#mask0_94_4210)'>
      <path
        opacity='0.5'
        d='M273.372 264.775C273.372 264.775 227.768 264.157 220.073 228.303C212.378 192.449 223.15 188.74 191.604 154.123C160.058 119.506 84.6519 96.634 67.7234 86.743C50.795 76.852 -18.4548 35.436 6.93652 -27.617C32.3278 -90.67 273.372 -18.963 273.372 -18.963V264.775Z'
        fill={variables['colors-mc-logo-1']}
      />
      <path
        d='M31.4868 -11.0321C29.7198 -8.20805 28.5785 -5.19208 28.1065 -2.09998C25.0142 13.516 32.1263 51.141 140.141 93.58C284.161 150.166 270.659 222.444 270.659 222.444V-0.0950928L31.4868 -11.0321Z'
        fill={variables['colors-mc-logo-1']}
      />
    </g>
  </svg>
);

export default LoginRightIcon;
